<template>
	<!--Article -->
	<div class="landing-words landing-words-details">
		<section class="" v-in-viewport="">
			<div class="inside">
				<div class="text-center headline-container container-fluid">
			  	 	<h1 class="headline" v-in-viewport="">Insights, commentary and news</h1>
			 	</div>
			</div>
		</section>
		<section class="content-article">
			<div class="inside">
				<div class="container-fluid" v-if="pageData.elements">
					<div class="content-article-body col-lg-9 col-sm-8 col-xs-12">
						<h4 class="type-name">{{pageData.elements.word_category.value[0].name}}</h4>
						<h2 class="title">{{pageData.elements.header_title.value}}</h2>
						<small class="date">{{pageData.elements.date.value | moment("add", "1 days","MMMM Do YYYY")}}</small>

						<div class="embed-container" v-if="pageData.elements.vimeo_id.value.length">
							<iframe :src="'https://player.vimeo.com/video/'+pageData.elements.vimeo_id.value+'?loop=1&title=0&byline=0&portrait=0&api=1&muted=1&autoplay=1'" width="640" height="360" frameborder="0"  allow="autoplay; fullscreen" allowfullscreen></iframe>							
						</div>

						<div class="mask-image" v-else-if="pageData.elements.thumbnail_image.value.length">
							<img v-lazy="pageData.elements.thumbnail_image.value[0].url" :alt="pageData.elements.thumbnail_image.value[0].name"/>
						</div>


						<div class="description" v-html="pageData.elements.main_content.value">

						</div>
					</div>
					<div class="content-article-author text-center col-lg-3 col-sm-4 col-xs-12"  v-if="authorData.elements">
						<div class="mask-image img-responsive" v-if="authorData.elements.image.value.length" :style="setBackgroundImage(authorData.elements.image.value[0].url)">
						</div>
						<h4 class="author-name">{{authorData.elements.name.value}}</h4>
						<h5 class="author-position">{{authorData.elements.position.value}}</h5>
						<div class="author-description" v-html="authorData.elements.bio.value">
						</div>

						<div class="related_articles">
							<h3>OTHER ARTICLES BY THIS AUTHOR</h3>
							<ul>
								<li v-for="art in relatedArticles">
									<a :href="art.elements.url.value">{{art.elements.header_title.value}}</a>
								</li>
							</ul>
						</div>

						<div class="newsletter">
							<h3>SIGN UP FOR OUR NEWSLETTER</h3>
							<newsletter></newsletter>
						</div>
					</div>
				</div>
			</div>
		</section>

	</div>
</template>

<script>
	import apiConnection from '../mixins/apiConnection.js';
	import seoModule from '../mixins/seoModule.js';
	import commons from '../mixins/common.js';
	import MailchimpSubscribe from '../components/newsletter.vue';
	require('../assets/img/n-arrow.png');

	export default{
		name: 'Article',
		data () {
		   return {
		   		pageData:[],
		   		authorData:[],
		   		relatedArticles:[],
		     	articles:[],
		     	thanks:false
		   }
		},
		created(){
			let url = (this.$route.path).split('/');
			this.getArticle(url[2]);
		},
		mounted () {
			setTimeout(function(){
			    $('.st-sticky-share-buttons').addClass('st-sticky-share-buttons-show')
			},1500);

		},
		mixins:[apiConnection, commons, seoModule],
		components:{
			'newsletter':MailchimpSubscribe
		},
	}
</script>



// WEBPACK FOOTER //
// Article.vue?3e8f88f2